// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__CK0Hc","up":"button_up__Xf7na","tri":"button_tri__upr7Q","sm":"button_sm__fhlCv","md":"button_md__K4hEv","lg":"button_lg__VzPcA"};